import { render, staticRenderFns } from "./ProjectTypeGroup.vue?vue&type=template&id=4ef8a49c&scoped=true&"
import script from "./ProjectTypeGroup.vue?vue&type=script&lang=js&"
export * from "./ProjectTypeGroup.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTypeGroup.vue?vue&type=style&index=0&id=4ef8a49c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef8a49c",
  null
  
)

export default component.exports